import React from "react";
import { Stack } from "@mui/material";

import { PagePrint } from "../PagePrint";

import CompanyInfo from "./CompanyInfo";
import ShipmentInfo from "./ShipmentInfo";
import ItemTable from "./ItemTable";
import SignatureSection from "./SignatureSection";
import { CheckerInfo } from "./CheckerInfo";
import { ShipmentMethod } from "./ShipmentMethod";
import { PackingBarcodes } from "../PackingBarcodes";

export const PackingSlip = ({
  id,
  shipmentNumber,
  soldTo,
  shipTo,
  shipDate,
  poNumber,
  shipVia,
  boxes,
  weight,
  checkedBy,
  items,
  includeSerialization,
  serialization = [],
  locationId,
  hideBoxes,
  ...rest
}) => {
  return (
    <>
      <PagePrint cardProps={{ className: "print-only", id: "page-1" }}>
        <CompanyInfo number={shipmentNumber || id} locationId={locationId} />
        <ShipmentInfo />
        <Stack flexGrow={1}>
          <ShipmentMethod poNumber={poNumber} />
          <ItemTable items={items} hideBoxes={hideBoxes} {...rest} />
          <CheckerInfo locationId={locationId} />
        </Stack>
        <SignatureSection />
      </PagePrint>
      {includeSerialization && (
        <PackingBarcodes
          serialization={serialization}
          weight={weight}
          packagedDate={shipDate}
          number={shipmentNumber || id}
        />
      )}
    </>
  );
};

export default PackingSlip;
